"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCreatePayoutKapiErrorToPayoutErrorCX = exports.isKapiReasonCode = exports.mapCreatePayoutLegacyErrorToPayoutErrorCX = exports.mapKapiToPaymentDetailsError = exports.genericError = void 0;
exports.genericError = { errorCode: 'GENERIC' };
var mapKapiToPaymentDetailsError = function (error) {
    if (error.graphQLErrors.length) {
        var mappedErrors = error.graphQLErrors
            .map(function (_a) {
            var extensions = _a.extensions, path = _a.path;
            if (extensions.code === 'FORBIDDEN' &&
                (path === null || path === void 0 ? void 0 : path.includes('paymentMandate'))) {
                return {
                    errorCode: 'DOES_NOT_OWN_MANDATE',
                };
            }
            return {
                errorCode: 'GENERIC',
            };
        })
            .filter(function (item) { return Boolean(item); });
        if (mappedErrors.length) {
            // The UI only handles one error so just return the first one.
            return mappedErrors[0];
        }
    }
    return exports.genericError;
};
exports.mapKapiToPaymentDetailsError = mapKapiToPaymentDetailsError;
var isLegacyReasonCode = function (reason) {
    return [
        'NoDirectDebitError',
        'BalanceWouldNotExceedDirectDebitError',
        'RefundAlreadyRequestedError',
        'IsLossCustomerError',
        'StaleMeterReadingError',
        'ExcessiveBalanceError',
        'BillingOnHoldError',
    ].includes(reason);
};
var mapCreatePayoutLegacyErrorToPayoutErrorCX = function (response) {
    var _a;
    var reasonCode = (((_a = response.response) === null || _a === void 0 ? void 0 : _a.data) || {}).reasonCode;
    return {
        reasonCode: reasonCode
            ? isLegacyReasonCode(reasonCode)
                ? reasonCode
                : 'GENERIC'
            : undefined,
    };
};
exports.mapCreatePayoutLegacyErrorToPayoutErrorCX = mapCreatePayoutLegacyErrorToPayoutErrorCX;
//Only a number of reason codes are supported in the UI
var isKapiReasonCode = function (reason) {
    return [
        'NO_ACTIVE_MANDATE',
        'PAYOUT_ALREADY_REQUESTED',
        'ACCOUNT_IN_LOSS',
        'NO_FRESH_METER_READING',
        'BILLING_ON_HOLD',
    ].includes(reason);
};
exports.isKapiReasonCode = isKapiReasonCode;
var mapCreatePayoutKapiErrorToPayoutErrorCX = function (error) {
    if (error.graphQLErrors.length) {
        var reasonCodes = error.graphQLErrors.flatMap(function (_a) {
            var extensions = _a.extensions;
            return extensions.error.message.reasonCodes;
        });
        if (reasonCodes === null || reasonCodes === void 0 ? void 0 : reasonCodes.every(function (reasonCode) { return reasonCode === undefined || reasonCode === null; })) {
            return {
                reasonCode: undefined,
            };
        }
        else {
            var mappedErrors = reasonCodes
                .filter(function (x) { return x !== undefined && x !== null; })
                .map(function (reasonCode) {
                return (0, exports.isKapiReasonCode)(reasonCode) ? reasonCode : 'GENERIC';
            });
            return {
                //UI currently only supports one reason code at a time and all have the same severity
                //so just return the first one
                reasonCode: mappedErrors[0],
            };
        }
    }
    return {
        reasonCode: undefined,
    };
};
exports.mapCreatePayoutKapiErrorToPayoutErrorCX = mapCreatePayoutKapiErrorToPayoutErrorCX;
